module.exports = __webpack_public_path__ + "static/img/image@2x (1).abba0106.png";